import React from 'react';
import EventForm from '../form';
import DetailsForm from '../details'
import { isEventDirector, isAdmin } from 'utils';

const DetailsTab = (props) => {
  const { permissions } = props;
  return (
    isEventDirector(permissions) ||  isAdmin(permissions)? 
    <DetailsForm {...props}/>
    :
    <EventForm {...props}/>
  )
};

export default DetailsTab;
